import React, { useCallback, useState } from 'react';
import * as Styles from './SslEv.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Input,
} from 'gatorcomponents';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';
import useLocale from '@/hooks/useLocale/useLocale';

export const SslEv = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { sslEV: sslEVLocale } = ticketsLocale.forms;
  const [formData, setFormData] = useState({
    installUrl: '',
    enterprisedocument: '',
    enterprisePhone: '',
    email: '',
    agreed: false,
  });

  const checkForm = useCallback(() => {
    let isOk = false;

    isOk = formData.installUrl
      && formData.enterprisedocument
      && formData.enterprisePhone
      && formData.email
      && formData.agreed;

    return !isOk;
  }, [
    formData,
  ]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: ticketsLocale.forms.names.sslEV,
      key: V2Forms.SSL_EV,
      tags: [
        'whmcs_form_financiero_upgrade-downgrade_plan',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
        ${sslEVLocale.body.product(selectedProduct)}
        ${sslEVLocale.body.request}
        ${sslEVLocale.placeholders.installUrl}: ${formData.installUrl}
        ${sslEVLocale.placeholders.enterprisedocument}: ${formData.enterprisedocument}
        ${sslEVLocale.placeholders.enterprisePhone}: ${formData.enterprisePhone}
        ${sslEVLocale.placeholders.email}: ${formData.email}
        ${sslEVLocale.body.agreed(formData.agreed)}
        ${sslEVLocale.body.productId(selectedProduct)}
        `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    sslEVLocale,
    submitForm,
    selectedProduct,
    formData,
  ]);


  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {sslEVLocale.info}
      </Styles.Info>

      <Styles.Title>
        {sslEVLocale.title}
      </Styles.Title>

      <Styles.InputsWrapper>
        <Styles.InputWrapper>
          <Input
            name="installUrl"
            placeholder={sslEVLocale.placeholders.installUrl}
            label={formData.installUrl ? sslEVLocale.placeholders.installUrl : ''}
            value={formData.installUrl}
            onChange={e => handleChange({ key: 'installUrl', value: e.target.value })}
            type="text"
            testId="installUrl"
          />
          <Styles.InfoText>
            {sslEVLocale.placeholders.installUrlInfo}
          </Styles.InfoText>
        </Styles.InputWrapper>

        <Input
          name="enterprisedocument"
          placeholder={sslEVLocale.placeholders.enterprisedocument}
          label={formData.enterprisedocument ? sslEVLocale.placeholders.enterprisedocument : ''}
          value={formData.enterprisedocument}
          onChange={e => handleChange({ key: 'enterprisedocument', value: e.target.value })}
          type="text"
          testId="enterprisedocument"
        />

        <Styles.InputWrapper>
          <Input
            name="enterprisePhone"
            placeholder={sslEVLocale.placeholders.enterprisePhone}
            label={formData.enterprisePhone ? sslEVLocale.placeholders.enterprisePhone : ''}
            value={formData.enterprisePhone}
            onChange={e => handleChange({ key: 'enterprisePhone', value: e.target.value })}
            type="text"
            testId="enterprisePhone"
          />
          <Styles.InfoText>
            {sslEVLocale.placeholders.enterprisePhoneInfo}
          </Styles.InfoText>
        </Styles.InputWrapper>

        <Styles.InputWrapper>
          <Input
            name="email"
            placeholder={sslEVLocale.placeholders.email}
            label={formData.email ? sslEVLocale.placeholders.email : ''}
            value={formData.email}
            onChange={e => handleChange({ key: 'email', value: e.target.value })}
            type="text"
            testId="email"
          />
          <Styles.InfoText>
            {sslEVLocale.placeholders.emailInfo}
          </Styles.InfoText>
        </Styles.InputWrapper>

        <Styles.CheckboxLabel
          htmlFor="#agreedTerms"
          data-testid="agreedTerms"
          onClick={() => handleChange({ key: 'agreed', value: !formData.agreed })}
        >
          <Checkbox checked={formData.agreed} id="agreed" />
          <Styles.Text>
            {sslEVLocale.placeholders.agreed}
          </Styles.Text>
        </Styles.CheckboxLabel>
      </Styles.InputsWrapper>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : sslEVLocale.send}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default SslEv;
